import { Controller } from "@hotwired/stimulus"

// Shows the custom start/end date inputs only when the "Custom range" timeframe
// is selected, so the preset timeframes don't surface fields they ignore.
export default class extends Controller {
  static targets = ["timeframe", "custom"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isCustom = this.timeframeTarget.value === "custom"
    this.customTargets.forEach((field) => field.classList.toggle("hidden", !isCustom))
  }
}
